import { useState } from 'react'
import { useAbm } from '../hooks/useAbm'
import AbmTable from '../components/AbmTable'
import Modal from '../components/Modal'
import Boton from '../components/Boton'

const EMPTY = { descripcion: '', codigo_presea: '', tipo: 'efectivo', cobrable: true, pagable: true, activo: true }
const TIPOS = ['efectivo', 'transferencia', 'tarjeta', 'cheque', 'mp', 'otro']

export default function ValoresPage() {
  const { rows, loading, create, update, remove } = useAbm('medios-pago')
  const [modal, setModal] = useState(null)
  const [form, setForm] = useState(EMPTY)
  const [saving, setSaving] = useState(false)
  const [err, setErr] = useState('')

  const openCreate = () => { setForm(EMPTY); setErr(''); setModal('new') }
  const openEdit = (row) => { setForm({ cobrable: true, pagable: true, ...row }); setErr(''); setModal(row) }

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true); setErr('')
    try {
      if (modal === 'new') await create(form)
      else await update(modal.id, form)
      setModal(null)
    } catch (error) {
      setErr(error.response?.data?.message || 'Error al guardar')
    } finally { setSaving(false) }
  }

  const set = (key) => e => setForm(f => ({ ...f, [key]: e.target.value }))
  const toggle = (key) => () => setForm(f => ({ ...f, [key]: !f[key] }))

  const columns = [
    { key: 'descripcion', label: 'Descripción' },
    { key: 'codigo_presea', label: 'Código Presea' },
    { key: 'tipo', label: 'Tipo' },
    { key: 'cobrable', label: 'Cobrable', render: v => v !== false ? <span style={badge('#dcfce7', '#166534')}>Sí</span> : <span style={badge('#fee2e2', '#991b1b')}>No</span> },
    { key: 'pagable', label: 'Pagable', render: v => v !== false ? <span style={badge('#dcfce7', '#166534')}>Sí</span> : <span style={badge('#fee2e2', '#991b1b')}>No</span> },
    { key: 'activo', label: 'Activo', render: v => v ? 'Sí' : 'No' },
  ]

  return (
    <div>
      <AbmTable title="Valores / Medios de Pago" columns={columns} rows={rows} loading={loading} onCreate={openCreate} onEdit={openEdit} onDelete={remove} />
      {modal && (
        <Modal title={modal === 'new' ? 'Nuevo Valor' : 'Editar Valor'} onClose={() => setModal(null)}>
          <form onSubmit={handleSave} style={st.form}>
            <div>
              <label style={st.label}>Descripción *</label>
              <input style={st.input} value={form.descripcion} onChange={set('descripcion')} required />
            </div>
            <div style={st.row}>
              <div style={{ flex: 1 }}>
                <label style={st.label}>Código Presea</label>
                <input style={st.input} value={form.codigo_presea || ''} onChange={set('codigo_presea')} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={st.label}>Tipo</label>
                <select style={st.input} value={form.tipo} onChange={set('tipo')}>
                  {TIPOS.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>
            </div>
            <div style={st.checkGroup}>
              <label style={st.checkRow}>
                <input type="checkbox" checked={!!form.cobrable} onChange={toggle('cobrable')} />
                Cobrable (puede usarse en cobranzas)
              </label>
              <label style={st.checkRow}>
                <input type="checkbox" checked={!!form.pagable} onChange={toggle('pagable')} />
                Pagable (puede usarse en pagos)
              </label>
              <label style={st.checkRow}>
                <input type="checkbox" checked={!!form.activo} onChange={toggle('activo')} />
                Activo
              </label>
            </div>
            {err && <p style={st.error}>{err}</p>}
            <div style={st.actions}>
              <Boton variante="ghost" type="button" onClick={() => setModal(null)}>Cancelar</Boton>
              <Boton variante="primary" type="submit" disabled={saving}>{saving ? 'Guardando...' : 'Guardar'}</Boton>
            </div>
          </form>
        </Modal>
      )}
    </div>
  )
}

const badge = (bg, color) => ({ padding: '2px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: '700', background: bg, color })

const st = {
  form: { display: 'flex', flexDirection: 'column', gap: '0.75rem' },
  row: { display: 'flex', gap: '0.75rem' },
  label: { display: 'block', fontWeight: '600', fontSize: '0.875rem', color: '#374151', marginBottom: '0.25rem' },
  input: { width: '100%', padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.9375rem', boxSizing: 'border-box' },
  checkGroup: { display: 'flex', flexDirection: 'column', gap: '0.5rem', background: '#f8fafc', padding: '0.75rem', borderRadius: '6px' },
  checkRow: { display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', cursor: 'pointer' },
  error: { color: '#dc2626', fontSize: '0.875rem', margin: 0 },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', marginTop: '0.5rem' },
}
